import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Button } from 'foundations-components/transitional/components/Button';
import { CharacterCounter } from 'foundations-components/transitional/components/CharacterCounter';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Form } from 'foundations-components/transitional/components/Form';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import ToolAccessModalError from './components/modal/ToolAccessModalError';
import ApproverSelect from './components/ApproverSelect';
import { useToolAccessRequestForm } from './hooks/useToolAccessRequestForm';
import { trackInteraction } from './utils/usageTracker';
import { CHANGE_APPROVER, SUBMIT_REQUEST, CANCEL_REQUEST, OPEN_MODAL } from './constants/trackingConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ToolAccessModal(props) {
  const {
    onClose,
    onComplete,
    show,
    toolAccess
  } = props;
  const {
    formState,
    setError,
    setApprover,
    setMessage,
    resetForm
  } = useToolAccessRequestForm();
  if (!show) {
    return null;
  }
  const onOpenStart = () => {
    trackInteraction(OPEN_MODAL);
  };
  const onRequestError = error => {
    var _error$cause$cause, _error$cause;
    setError((_error$cause$cause = (_error$cause = error.cause) === null || _error$cause === void 0 ? void 0 : _error$cause.cause) !== null && _error$cause$cause !== void 0 ? _error$cause$cause : null);
  };
  const onSubmit = evt => {
    evt.preventDefault();
    setError(null);
    if (!formState.approver) {
      return;
    }
    const data = {
      approver: formState.approver,
      message: formState.message
    };
    toolAccess.createRequest(data, response => {
      FloatingAlertStore.addAlert({
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "toolAccess.requestSent"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "toolAccess.requestSentToApprover",
          options: Object.assign({}, formState.approver)
        }),
        type: 'success',
        'data-test-id': 'ui-tool-access-request-sent-alert'
      });
      if (typeof onComplete === 'function') {
        onComplete(response);
      }
    }, onRequestError);
    trackInteraction(SUBMIT_REQUEST);
  };
  const onChangeApprover = approver => {
    setApprover(approver);
    trackInteraction(CHANGE_APPROVER);
  };
  const onChangeMessage = evt => {
    setMessage(evt.target.value);
  };
  const onCancel = () => {
    onClose();
    resetForm();
    trackInteraction(CANCEL_REQUEST);
  };
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "ui-tool-access-request-modal",
    width: 600,
    onOpenStart: onOpenStart,
    children: [toolAccess.loading && /*#__PURE__*/_jsx(LoadingOverlay, {
      contextual: true
    }), /*#__PURE__*/_jsxs(Form, {
      onSubmit: onSubmit,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "toolAccess.requestPermissionUpdate"
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onCancel
        })]
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [formState.error && /*#__PURE__*/_jsx(ToolAccessModalError, {
          error: formState.error
        }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "toolAccess.modalDescription",
          options: {
            toolName: toolAccess.toolName
          }
        }), /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "toolAccess.approver"
          }),
          required: true,
          children: /*#__PURE__*/_jsx(ApproverSelect, {
            value: formState.approver,
            onChange: onChangeApprover
          })
        }), /*#__PURE__*/_jsx(CharacterCounter, {
          onChange: onChangeMessage,
          value: formState.message,
          renderInput: readerProps => /*#__PURE__*/_jsx(FormControl, {
            characterCount: readerProps.count,
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "toolAccess.message"
            }),
            children: /*#__PURE__*/_jsx(TextArea, {
              "data-test-id": "ui-tool-access-request-modal-message",
              placeholder: I18n.text('toolAccess.messageOptional'),
              value: readerProps.value,
              onChange: readerProps.onChange,
              maxLength: 200
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          "data-test-id": "ui-tool-access-modal-submit-button",
          use: "primary",
          type: "submit",
          disabled: !formState.approver,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "toolAccess.sendRequest"
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "secondary",
          onClick: onCancel,
          "data-test-id": "tool-access-modal-cancel",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "toolAccess.cancel"
          })
        })]
      })]
    })]
  });
}
export default ToolAccessModal;